import script from "./RacingRightSidebarFixture.vue?vue&type=script&setup=true&lang=js"
export * from "./RacingRightSidebarFixture.vue?vue&type=script&setup=true&lang=js"

import "./RacingRightSidebarFixture.vue?vue&type=style&index=0&id=7eb0a56e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7eb0a56e"]])

export default __exports__